import React from 'react';
import Icon from 'components/DesignSystem/Icon';
import Button from 'components/DesignSystem/Button';
import SubtitleSemiBold from 'components/Typography/SubtitleSemiBold';
import BodyRegular from 'components/Typography/BodyRegular';
import './index.scss';

export interface QueryErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  /** Texto do botão de retry. Padrão: "Tentar novamente". */
  retryLabel?: string;
  className?: string;
}

export default function QueryErrorState({
  title = 'Não foi possível carregar os dados',
  message = 'Tente novamente em alguns instantes.',
  onRetry,
  retryLabel = 'Tentar novamente',
  className = '',
}: QueryErrorStateProps) {
  return (
    <div className={`query-error-state ${className}`}>
      <div className="query-error-state__card">
        <div className="query-error-state__icon" aria-hidden="true">
          <Icon iconType="warning" size="large" />
        </div>
        <div className="query-error-state__title"><SubtitleSemiBold>{title}</SubtitleSemiBold></div>
        <div className="query-error-state__message"><BodyRegular>{message}</BodyRegular></div>
        {onRetry && (
          <Button icon="refresh" onClick={onRetry} className="query-error-state__retry">
            {retryLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
